export default "__VITE_ASSET__ChBMkGxo__"